import { render, staticRenderFns } from "./PercentBar.vue?vue&type=template&id=796eb6aa&"
import script from "./PercentBar.vue?vue&type=script&lang=js&"
export * from "./PercentBar.vue?vue&type=script&lang=js&"
import style0 from "./PercentBar.vue?vue&type=style&index=0&id=796eb6aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports